import posthog from "posthog-js";

export default {
    install(Vue) {
        posthog.init(process.env.VUE_APP_POSTHOG_TOKEN, {
            api_host: process.env.VUE_APP_POSTHOG_HOST,
            defaults: "2026-01-30"
        });
        Vue.prototype.$posthog = posthog;
    }
};
